// src/redux/actionTypes.js
export const FETCH_DATA_REQUEST = 'FETCH_DATA_REQUEST';
export const FETCH_DATA_SUCCESS = 'FETCH_DATA_SUCCESS';
export const FETCH_DATA_FAILURE = 'FETCH_DATA_FAILURE';
export const SET_DATE = 'SET_DATE';

export const FETCH_REALTIME_LINE_ACTIVITY_REQUEST = "FETCH_REALTIME_LINE_ACTIVITY_REQUEST";
export const FETCH_REALTIME_LINE_ACTIVITY_SUCCESS = "FETCH_REALTIME_LINE_ACTIVITY_SUCCESS";
export const FETCH_REALTIME_LINE_ACTIVITY_FAILURE = "FETCH_REALTIME_LINE_ACTIVITY_FAILURE";

export const REAL_TIME_LINE_ACTIVITY_NON_SEED_REQUEST = "REAL_TIME_LINE_ACTIVITY_NON_SEED_REQUEST";
export const REAL_TIME_LINE_ACTIVITY_NON_SEED_SUCCESS = "REAL_TIME_LINE_ACTIVITY_NON_SEED_SUCCESS";
export const REAL_TIME_LINE_ACTIVITY_NON_SEED_FAILURE = "REAL_TIME_LINE_ACTIVITY_NON_SEED_FAILURE";

export const FETCH_REALTIME_WAREHOUSE_ACTIVITY_REQUEST = "FETCH_REALTIME_WAREHOUSE_ACTIVITY_REQUEST";
export const FETCH_REALTIME_WAREHOUSE_ACTIVITY_SUCCESS = "FETCH_REALTIME_WAREHOUSE_ACTIVITY_SUCCESS";
export const FETCH_REALTIME_WAREHOUSE_ACTIVITY_FAILURE = "FETCH_REALTIME_WAREHOUSE_ACTIVITY_FAILURE";

export const FETCH_REALTIME_WAREHOUSE_LINE_REQUEST = "FETCH_REALTIME_WAREHOUSE_LINE_REQUEST";
export const FETCH_REALTIME_WAREHOUSE_LINE_SUCCESS = "FETCH_REALTIME_WAREHOUSE_LINE_SUCCESS";
export const FETCH_REALTIME_WAREHOUSE_LINE_FAILURE = "FETCH_REALTIME_WAREHOUSE_LINE_FAILURE";

export const FETCH_REALTIME_WAREHOUSE_COUNT_REQUEST = "FETCH_REALTIME_WAREHOUSE_COUNT_REQUEST";
export const FETCH_REALTIME_WAREHOUSE_COUNT_SUCCESS = "FETCH_REALTIME_WAREHOUSE_COUNT_SUCCESS";
export const FETCH_REALTIME_WAREHOUSE_COUNT_FAILURE = "FETCH_REALTIME_WAREHOUSE_COUNT_FAILURE";

export const DRIER_STATUS_REQUEST = "DRIER_STATUS_REQUEST";
export const DRIER_STATUS_SUCCESS = "DRIER_STATUS_SUCCESS";
export const DRIER_STATUS_FAILURE = "DRIER_STATUS_FAILURE";

// Action Types for Even Drier Status Report
export const FETCH_DRIER_STATUS_REPORT_EVEN_REQUEST = 'FETCH_DRIER_STATUS_REPORT_EVEN_REQUEST';
export const FETCH_DRIER_STATUS_REPORT_EVEN_SUCCESS = 'FETCH_DRIER_STATUS_REPORT_EVEN_SUCCESS';
export const FETCH_DRIER_STATUS_REPORT_EVEN_FAILURE = 'FETCH_DRIER_STATUS_REPORT_EVEN_FAILURE';

// Action Types for Odd Drier Status Report    FETCH_DRYING_TRANSACTION_TEMP_REQUEST
export const FETCH_DRIER_STATUS_REPORT_ODD_REQUEST = 'FETCH_DRIER_STATUS_REPORT_ODD_REQUEST';
export const FETCH_DRIER_STATUS_REPORT_ODD_SUCCESS = 'FETCH_DRIER_STATUS_REPORT_ODD_SUCCESS';
export const FETCH_DRIER_STATUS_REPORT_ODD_FAILURE = 'FETCH_DRIER_STATUS_REPORT_ODD_FAILURE';

export const FETCH_DRYING_TRANSACTION_TEMP_REQUEST = 'FETCH_DRYING_TRANSACTION_TEMP_REQUEST';
export const FETCH_DRYING_TRANSACTION_TEMP_SUCCESS = 'FETCH_DRYING_TRANSACTION_TEMP_SUCCESS';
export const FETCH_DRYING_TRANSACTION_TEMP_FAILURE = 'FETCH_DRYING_TRANSACTION_TEMP_FAILURE';

// actionTypes.js
export const FETCH_WAREHOUSE_STATUS_REQUEST = 'FETCH_WAREHOUSE_STATUS_REQUEST';
export const FETCH_WAREHOUSE_STATUS_SUCCESS = 'FETCH_WAREHOUSE_STATUS_SUCCESS';
export const FETCH_WAREHOUSE_STATUS_FAILURE = 'FETCH_WAREHOUSE_STATUS_FAILURE';

export const FETCH_WAREHOUSE_STATUS_LINE_SEED_REQUEST = "FETCH_WAREHOUSE_STATUS_LINE_SEED_REQUEST";
export const FETCH_WAREHOUSE_STATUS_LINE_SEED_SUCCESS = "FETCH_WAREHOUSE_STATUS_LINE_SEED_SUCCESS";
export const FETCH_WAREHOUSE_STATUS_LINE_SEED_FAILURE = "FETCH_WAREHOUSE_STATUS_LINE_SEED_FAILURE";

export const FETCH_WAREHOUSE_STATUS_LINE_NON_SEED_REQUEST = "FETCH_WAREHOUSE_STATUS_LINE_NON_SEED_REQUEST";
export const FETCH_WAREHOUSE_STATUS_LINE_NON_SEED_SUCCESS = "FETCH_WAREHOUSE_STATUS_LINE_NON_SEED_SUCCESS";
export const FETCH_WAREHOUSE_STATUS_LINE_NON_SEED_FAILURE = "FETCH_WAREHOUSE_STATUS_LINE_NON_SEED_FAILURE";


// fetch Org
export const FETCH_ORGANIZATION_REQUEST = "FETCH_ORGANIZATION_REQUEST";
export const FETCH_ORGANIZATION_SUCCESS = "FETCH_ORGANIZATION_SUCCESS";
export const FETCH_ORGANIZATION_FAILURE = "FETCH_ORGANIZATION_FAILURE";
